(()=>{
  function init(root){
    if(root.dataset.lbReady)return;
    root.dataset.lbReady='true';
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    const main=root.querySelector('[data-lb-main]');
    const photos=[...root.querySelectorAll('[data-lb-photo]')];
    const caption=root.querySelector('[data-lb-caption]');
    let index=0;
    function select(next){
      index=(next+photos.length)%photos.length;
      const item=photos[index];
      main.src=item.dataset.src;
      main.removeAttribute('srcset');
      main.alt=item.dataset.alt;
      caption.textContent=item.dataset.caption;
      photos.forEach((photo,i)=>photo.setAttribute('aria-pressed',String(i===index)));
      const rail=root.querySelector('.lb-thumbs');
      rail.scrollTo({left:item.offsetLeft-rail.offsetLeft-rail.clientWidth/2+item.clientWidth/2,behavior:reduced?'instant':'smooth'});
    }
    photos.forEach((photo,i)=>photo.addEventListener('click',()=>select(i)));
    root.querySelector('[data-lb-prev]').addEventListener('click',()=>select(index-1));
    root.querySelector('[data-lb-next]').addEventListener('click',()=>select(index+1));
    const stage=root.querySelector('[data-lb-stage]');
    stage.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'){event.preventDefault();select(index-1)}if(event.key==='ArrowRight'){event.preventDefault();select(index+1)}});
    let touch=null;
    stage.addEventListener('touchstart',event=>{const t=event.changedTouches[0];touch={x:t.clientX,y:t.clientY}},{passive:true});
    stage.addEventListener('touchend',event=>{if(!touch)return;const t=event.changedTouches[0];const dx=t.clientX-touch.x,dy=t.clientY-touch.y;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)select(index+(dx<0?1:-1));touch=null},{passive:true});
    const modal=root.querySelector('[data-lb-lightbox]');
    root.querySelector('[data-lb-zoom]').addEventListener('click',()=>{const img=modal.querySelector('img');img.src=main.currentSrc||main.src;img.alt=main.alt;modal.showModal()});
    root.querySelector('[data-lb-close]').addEventListener('click',()=>modal.close());
    modal.addEventListener('click',event=>{if(event.target===modal)modal.close()});
    root.querySelector('[data-lb-light]').addEventListener('click',event=>{const button=event.currentTarget;const active=button.getAttribute('aria-pressed')!=='true';button.setAttribute('aria-pressed',String(active));root.querySelector('[data-lb-room]').classList.toggle('is-dim',active)});
    root.querySelector('[data-lb-drawer]')?.addEventListener('click',event=>{const button=event.currentTarget;const active=button.getAttribute('aria-pressed')!=='true';button.setAttribute('aria-pressed',String(active));button.closest('.lb-drawer-demo').classList.toggle('is-open',active)});
    const form=root.querySelector('.lb-form');
    form.addEventListener('submit',async event=>{
      if(!window.fetch)return;
      event.preventDefault();
      const button=form.querySelector('button[type=submit]');
      if(button.disabled)return;
      const label=button.querySelector('span');const original=label.textContent;const error=form.querySelector('.lb-error');
      error.hidden=true;button.disabled=true;button.setAttribute('aria-busy','true');label.textContent=root.dataset.adding;
      const data=new FormData(form);
      const item={id:Number(data.get('id')),quantity:Number(data.get('quantity')||1)};
      try{
        if(window.VoyageCart?.add){await window.VoyageCart.add([item])}
        else{
          const result=await fetch(root.dataset.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})});
          const json=await result.json();if(!result.ok)throw new Error(json.description||root.dataset.error);location.assign(root.dataset.cartUrl);
        }
      }catch(e){error.textContent=e.message||root.dataset.error;error.hidden=false}
      finally{button.disabled=false;button.removeAttribute('aria-busy');label.textContent=original}
    });
    if('IntersectionObserver' in window){
      const sticky=root.querySelector('[data-lb-sticky]');
      const observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||entries[0].boundingClientRect.top>0},{threshold:0});observer.observe(form);
      if(!reduced){root.classList.add('lb-motion');const reveal=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('lb-wait');reveal.unobserve(entry.target)}}),{threshold:.08});root.querySelectorAll('.lb-reveal').forEach(el=>{el.classList.add('lb-wait');reveal.observe(el)})}
    }
  }
  const boot=()=>document.querySelectorAll('[data-lb]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
})();
